export const REVENUE_TABS = {
  totalRevenue: 'total_revenue',
  extraStats: 'extra_stats',
};

export const REVENUE_TYPE = {
  virtual: 'virtual',
  independent: 'independent',
};
